import { Box, Button, Card, CircularProgress, Grid, IconButton, Typography } from '@mui/material';
import { ReactComponent as FailIcon } from '../../assets/icons/condash-failicon.svg';
import { ReactComponent as SuccessIcon } from '../../assets/icons/condash-success.svg';
import { ReactComponent as ListBoxIcon } from '../../assets/icons/condash-listbox.svg';
import { ReactComponent as RightArrowIcon } from '../../assets/icons/condash-right-icon.svg';
import { ReactComponent as LeftArrowIcon } from '../../assets/LeftArrowIcon.svg';
import { ReactComponent as VerticalLine } from '../../assets/icons/condashvr-line.svg';
import { useEffect, useMemo, useState } from 'react';
import { AssetList } from './assetsList';
import { ConnectivityCard } from './connectivityCard';
import { connect, useDispatch } from 'react-redux';
import { connectivityDashboardActions } from '../../store/reducers/connectivity-dashboard';
import { ontologyMasterActions } from '../../store/reducers/ontology-master';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { InputAdornment, TextField } from '@mui/material';
import { ReactComponent as Search } from '../../assets/icons/main/search-icon.svg';
import { pageActions } from '../../store/reducers/page-actions';
import { Link } from 'react-router-dom';

const Styles = {
  input: {
    width: '300px',
    borderRadius: '8px',
    height: '42px',
    border: 'none',
  },
  cardinnertext: {
    color: '#64759F',
    fontSize: '14px',
    fontWeight: '400',
    fontStyle: 'normal',
    lineHeight: 'normal',
  },
  cardinnernum: {
    color: '#434D67',
    fontSize: '16px',
    fontWeight: '600',
    fontStyle: 'normal',
    lineHeight: 'normal',
  },
  cardheader: {
    color: '#434D67',
    fontSize: '20px',
    fontWeight: '400',
    fontStyle: 'normal',
    lineHeight: 'normal',
    marginTop: '-4px',
  },
};

const ConnectivityDashboard = ({ connectivityDasboardData, ontologyData, ontologyMgmntData, isDataLoading }: any) => {
  const [machineListPopup, setMachineListPopup] = useState<any>(false);
  const [dashboardData, setDashboardData] = useState<any>([]);
  const { state, pathname } = useLocation();
  const paramData = useParams();
  const [levelData, setLevelData] = useState<any>({
    onto_manage_title: '',
    level_number: 1,
    onto_manage_id: 0,
    parent_id: 0,
    level_name: '',
    assets: [],
  });
  const [selectedAssets, setSelectedAssets] = useState<any>({});
  const [currentPath, setCurrentPath] = useState<any>([]);

  const dispatch = useDispatch();

  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const data: any = {
      ontology_filter: 0,
      limit: 100,
      skip: 0,
      parent_id: 0,
    };

    dispatch(ontologyMasterActions.getOntologyList(''));
    dispatch(ontologyMasterActions.getOntologyMgmntList(''));
    dispatch(connectivityDashboardActions.getConDashboardDataRequest(data));
  }, [paramData]);

  useEffect(() => {
    if (paramData.level_number) {
      const data: any = ontologyData.filter((item: any) => item.level_number == paramData.level_number)[0];
      if (data) {
        setLevelData({
          onto_manage_title: '',
          level_number: data.level_number + 1,
          onto_manage_id: paramData.onto_id ? parseInt(paramData.onto_id) : 0,
          parent_id: 0,
          level_id: data.id,
          level_name: data.level_name,
          assets: [],
        });
      }
    } else {
      const data: any = ontologyData.filter((item: any) => item.level_number === 1)[0];
      if (data) {
        setLevelData({
          onto_manage_title: '',
          level_number: data.level_number,
          level_id: data.id,
          onto_manage_id: 0,
          parent_id: 0,
          level_name: data.level_name,
          assets: [],
        });
      }
    }

    if (pathname.length) {
      const pathnamesTemp: any = pathname.split('/').filter(Boolean);
      if (pathnamesTemp.length > 1) {
        const pathnamesData: any = [];

        ontologyData.forEach((item: any, index: any) => {
          if (pathnamesTemp[1] >= item.level_number) {
            let temp: any = {};
            if (pathnamesTemp[1] == item.level_number) {
              temp = {
                levelName: item.level_name,
                level_number: item.level_number,
                route: '',
                pathName: item.level_name,
                navigate: false,
              };
            } else {
              let _p = getParentId(pathnamesTemp[2], item.id);
              if (_p.parent_id === 0) {
                temp = {
                  levelName: item.level_name,
                  level_number: item.level_number,
                  route: pathnamesTemp[0],
                  pathHeading: item.level_name,
                  pathName: _p.onto_manage_title,
                  navigate: true,
                };
              } else {
                temp = {
                  levelName: item.level_name,
                  level_number: item.level_number,
                  route: pathnamesTemp[0] + '/' + item.level_number + '/' + _p.parent_id,
                  pathHeading: item.level_name,
                  pathName: _p.onto_manage_title,
                  navigate: true,
                };
              }
            }
            pathnamesData.push(temp);
            temp = {};
          }
        });

        // setCurrentPath(pathnamesData)
        dispatch(pageActions.setPagePath(pathnamesData.sort((a: any, b: any) => a.level_number - b.level_number)));
        return () => {
          const data: any = [];
          dispatch(pageActions.setPagePath(data));
        };
      }
    }
  }, [ontologyData, ontologyMgmntData, pathname]);

  const getParentId = (ontoid: number, level_number: number) => {
    let ontoId = ontoid;
    if (ontologyMgmntData.length > 0) {
      let tempOntoData: any = [];
      restartTheLoop: while (true) {
        for (const item of ontologyMgmntData) {
          if (item.onto_manage_id == ontoId) {
            tempOntoData.unshift(item);
            ontoId = item.parent_id;
            continue restartTheLoop;
          }
        }
        break;
      }
      if (tempOntoData.length) {
        let parentdata = tempOntoData.filter((item: any) => item.onto_level_number === level_number);
        if (parentdata.length) {
          return parentdata[0];
        } else {
          return { parenti_id: 0 };
        }
      } else {
        return { parenti_id: 0 };
      }
    } else {
      return { parenti_id: 0 };
    }
  };

  useEffect(() => {
    setDashboardData(connectivityDasboardData);
  }, [connectivityDasboardData]);

  const closeModal = () => {
    setMachineListPopup(false);
  };

  const openModal = (data: any) => {
    setSelectedAssets(data);
    setMachineListPopup(true);
  };

  const getLevelData = (data: any) => {};

  useEffect(() => {
    if (connectivityDasboardData.length) {
      if (levelData.level_number > 1) {
        setDashboardData(
          connectivityDasboardData
            .filter((item: any) => {
              return item.parent_id == paramData.onto_id;
            })
            .map((item: any) => {
              let num: any = paramData.level_number;
              return { ...item, level_number: parseInt(num) };
            })
            .filter((item: any) => item.onto_manage_title.toLowerCase().includes(searchTerm.toLowerCase()))
        );
      } else {
        setDashboardData(
          connectivityDasboardData
            .filter((item: any) => {
              return item.onto_level_number === levelData.level_id;
            })
            .map((item: any) => {
              return { ...item, level_number: 1 };
            })
            .filter((item: any) => item.onto_manage_title.toLowerCase().includes(searchTerm.toLowerCase()))
        );
      }
    }
  }, [levelData, connectivityDasboardData, searchTerm]);

  const handleChange = (e: any) => {
    setSearchTerm(e.target.value);
  };

  if (isDataLoading) {
    return <CircularProgress />;
  }
  return (
    <>
      <Box>
        <Grid container direction='row' alignItems={'center'} paddingBottom={'30px'}>
          <Grid
            xs={6}
            padding={'0'}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'baseline',
            }}
          >
            <Typography sx={Styles.cardheader}>Select {levelData.level_name} </Typography>
            {/* {(levelData.level_number != 1) ?
                            currentPath.map((item: any) => (<>
                                {(item.navigate) ? <IconButton sx={{ cursor: 'pointer', fontSize: '1rem', padding:'2px', color: '#5C85FF', ":hover": { backgroundColor: 'transparent', background: 'transparent' } }} component={Link} to={'/' + item.route}>{item.levelName}: <b>&nbsp;{item.pathName}</b> <span style={{ color: '#434D67', marginLeft: '5px' }}>/</span> </IconButton> : <Typography sx={Styles.cardheader}>&nbsp;Select {levelData.level_name} </Typography>}
                            </>)) : <Typography sx={Styles.cardheader}>Select {levelData.level_name} </Typography>
                        } */}
          </Grid>
          <Grid xs={6} sx={{ display: 'flex', justifyContent: 'end' }}>
            <Box display={'flex'} justifyContent={'end'} alignItems={'center'}>
              {/* {(levelData.level_number!=1) && <> <Button component={Link}  to={`/${(currentPath.length > 1) ? currentPath[currentPath.length -2]['route'] : ''}`} variant="outlined" sx={{borderRadius:'8px', padding:'9px, 16px, 9px, 16px', backgroundColor:'white', height:'42px'}} > <LeftArrowIcon/> Back</Button>
                            <VerticalLine style={{marginRight:'16px', marginLeft:'16px'}}/></> } */}

              {/* {(levelData.level_number!=1) && <> <Button onClick={()=>{navigate(-1)}} variant="outlined" sx={{borderRadius:'8px', padding:'9px, 16px, 9px, 16px', backgroundColor:'white', height:'42px'}} > <LeftArrowIcon/> Back</Button>
                            <VerticalLine style={{marginRight:'16px', marginLeft:'16px', height:'42px'}}/></> } */}
              <TextField
                placeholder='Search'
                variant='outlined'
                color='secondary'
                // startAdornment={<img src={search}></img>}
                onChange={handleChange}
                sx={{
                  ...Styles.input,
                  '& .MuiOutlinedInput-root': { backgroundColor: 'white', padding: '9px 16px', fontSize: '16px' },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='start'>
                      <Search />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </Grid>
        </Grid>
        <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3, lg: 3 }}>
          {dashboardData.map((item: any) => (
            <Grid item sm={6} md={4} lg={3}>
              <ConnectivityCard
                openModal={openModal}
                data={item}
                getLevelData={getLevelData}
                ontologyMgmntData={ontologyMgmntData}
                levelLength={ontologyData.length}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
      {machineListPopup && (
        <AssetList
          title={'List of Assets : ' + selectedAssets?.onto_manage_title}
          isOpen={machineListPopup}
          handleClose={closeModal}
          data={selectedAssets}
        />
      )}
    </>
  );
};

const mapStateToProps = (state: any) => ({
  connectivityDasboardData: state.connectivityDashboard.conDashData,
  ontologyData: state.ontologyMaster.ontologyData,
  ontologyMgmntData: state.ontologyMaster.ontologyMgmntData,
  isDataLoading: state.connectivityDashboard.isDataLoading,
});

export default connect(mapStateToProps)(ConnectivityDashboard);
